enum MakeModelChatQuestionType {
    default = 0,
    BodyStyle,
    PowerPreference,
    FuelType,
    Trim,
    Colour,
    Transmission
}

export default MakeModelChatQuestionType;
